import { Text, View } from '@react-pdf/renderer';

import { Table } from '../../../../../components/pdf';
import { Column } from '../../../../../components/pdf/tables/Table.types';
import { TEXT_CONTENT } from '../../../../../utils/constants';
import {
  DATE_FORMAT,
  isValidDate,
  toDisplayDate,
} from '../../../../../utils/date';

interface DataItem {
  title: string;
  values: string[];
}
export interface ForcedShiftData {
  id: string;
  shiftStartDateHour: string;
  shiftEndDateHour: string;
  providerType: string;
  shiftLength: number;
}
export interface PdfUserParamsProps {
  data: { [key: string]: DataItem };

  forcedShifts: ForcedShiftData[];
}
export default function PdfUserParams({
  data,
  forcedShifts,
}: PdfUserParamsProps) {
  return (
    <View
      style={{
        borderColor: '#bfbfbf',
        borderWidth: 1,
      }}
    >
      <Text
        style={{
          fontSize: 15,
          textAlign: 'left',
          fontWeight: 700,
          paddingHorizontal: 10,
          paddingVertical: 10,
          borderColor: '#bfbfbf',
          borderWidth: 1,
          backgroundColor: '#d3d3d3',
        }}
      >
        Input Parameters
      </Text>
      <View
        style={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          paddingHorizontal: 5,
          paddingVertical: 5,
          gap: '15',
        }}
      >
        {Object.values(data).map((each, key) => (
          <View
            key={key}
            style={{
              flex: '1 1 48%',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <BulletedCollection title={each.title} data={each.values} />
          </View>
        ))}
      </View>
      <View style={{ margin: 5 }}>
        <Table
          title={TEXT_CONTENT.FORCED_SHIFTS_DETAILS}
          rows={forcedShifts || []}
          columns={columns}
        />
      </View>
    </View>
  );
}

const BulletedCollection = ({
  title = 'Sample',
  data = ['sample 1'],
}: {
  title: string;
  data: string[];
}) => {
  return (
    <View>
      <Text
        style={{
          fontSize: 12,
          textAlign: 'left',
          fontWeight: 500,
          marginVertical: 5,
        }}
      >
        {title}
      </Text>
      <View style={{ marginLeft: 15 }}>
        {data.map((d, key) => (
          <View
            key={key}
            style={{
              display: 'flex',
              flexDirection: 'row',
              gap: 5,
              alignItems: 'center',
            }}
          >
            <Text
              style={{
                fontSize: 15,
                color: '#000',
              }}
            >
              {'\u2022'}
            </Text>
            <Text style={{ fontSize: 10 }}>{d}</Text>
          </View>
        ))}
      </View>
    </View>
  );
};

let columns: Column[] = [
  {
    field: 'shiftStartDateHour',
    headerName: TEXT_CONTENT.SHIFT_START,
    renderCell: ({ value }) =>
      value && isValidDate(value)
        ? toDisplayDate(value, DATE_FORMAT.DAY_WITH_TIME)
        : '',
  },
  {
    field: 'shiftEndDateHour',
    headerName: TEXT_CONTENT.SHIFT_END,
    renderCell: ({ value }) =>
      value && isValidDate(value)
        ? toDisplayDate(value, DATE_FORMAT.DAY_WITH_TIME)
        : '',
  },
  {
    field: 'providerType',
    headerName: TEXT_CONTENT.PROVIDER_TYPE,
  },
  {
    field: 'shiftLength',
    headerName: TEXT_CONTENT.SHIFT_LENGTH,
  },
];
